var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconPlus = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12 4.5C11.586 4.5 11.25 4.836 11.25 5.25V11.25H5.25C4.836 11.25 4.5 11.586 4.5 12C4.5 12.414 4.836 12.75 5.25 12.75H11.25V18.75C11.25 19.164 11.586 19.5 12 19.5C12.414 19.5 12.75 19.164 12.75 18.75V12.75H18.75C19.164 12.75 19.5 12.414 19.5 12C19.5 11.586 19.164 11.25 18.75 11.25H12.75V5.25C12.75 4.836 12.414 4.5 12 4.5Z", fill: "black" }))),
        alt: 'Icon Plus',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconPlus;
//# sourceMappingURL=index.js.map